import { create } from 'zustand'

interface NavigationState {
  sidebarOpen: boolean // Mobile: overlay visible
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
}

export const useNavigationStore = create<NavigationState>()((set) => ({
  sidebarOpen: false,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
}))
